var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input, HostListener } from '@angular/core';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
var PaletteComponent = /** @class */ (function (_super) {
    __extends(PaletteComponent, _super);
    function PaletteComponent(injector, paletteService) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.paletteService = paletteService;
        return _this;
    }
    PaletteComponent.prototype.ngOnInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.paletteService.createPalette('palette', _this.lc('ConfigureVariableName'));
            _this.changePaletteSize();
        }, 50);
    };
    PaletteComponent.prototype.onResize = function (event) {
        this.changePaletteSize();
    };
    PaletteComponent.prototype.changePaletteSize = function () {
        var paletteHeight = $('body').height() - $('.workshop').height();
        $('#palette').height(paletteHeight - 40);
    };
    __decorate([
        Input()
    ], PaletteComponent.prototype, "configureId", void 0);
    __decorate([
        HostListener('window:resize', ['$event'])
    ], PaletteComponent.prototype, "onResize", null);
    PaletteComponent = __decorate([
        Component({
            selector: 'configure-palette',
            template: "<div class=\"design-palette\"> <div class=\"component\"> <div class=\"componentTitle configTitle\">{{lc(\"Component\")}}</div> <div id=\"palette\" class=\"palette\"></div> </div> </div> ",
            styles: [".design-palette { .component { float: left; width: 220px; .palette { background: #fff; -webkit-tap-highlight-color: #ffffff; cursor: auto; } } }"],
        })
    ], PaletteComponent);
    return PaletteComponent;
}(ConfigureComponentBase));
export { PaletteComponent };
